<template>
  <div>
    <v-card>
      <v-card-title>Shining stars of Sparkle Series</v-card-title>
      <v-card-text>
        <!-- <v-avatar left>
          <v-icon>mdi-account-circle</v-icon>
        </v-avatar> -->
        <!-- <h3>STUDENTS WITH BEST PROJECTS</h3>
        <v-btn text color="green darken-4">
          Alka Kumari, JNV Mohendergarh </v-btn
        ><br />
        <v-btn text color="green darken-4"> Kajal Kashyap, JNV Kabirdham </v-btn
        ><br /> -->

        <br />
        <br />
        <v-avatar left> <v-icon>mdi-school</v-icon> </v-avatar>
        <h3>BEST PERFORMING SCHOOLS</h3>
        <v-btn text color="deep-orange darken-4"> JNV NALGONDA</v-btn><br />
        <v-btn text color="deep-orange darken-4"> JNV INDORE</v-btn><br />
        <v-btn text color="deep-orange darken-4"> JNV CHIKKAMAGLURU </v-btn
        ><br />
        <v-btn text color="deep-orange darken-4"> JNV IDUKKI</v-btn><br />
        <v-btn text color="deep-orange darken-4"> JNV CHAMPAWAT</v-btn><br />
      </v-card-text>
    </v-card>
    <!-- <v-card>
      <v-card-title>Shining stars of Sparkle Series: Session 3</v-card-title>
      <v-card-text>
        <v-avatar left>
          <v-icon>mdi-account-circle</v-icon>
        </v-avatar>
        <h3>STUDENTS WITH BEST PROJECTS</h3>
        <v-btn text color="green darken-4">
          Ar, JNV Jhansi </v-btn
        ><br />
        <v-btn text color="green darken-4"> Krishna Priya, JNV Nalgonda </v-btn
        ><br />

        <v-btn text color="green darken-4"> Mannat Chauhan, JNV Shimla </v-btn
        ><br />
        <v-btn text color="green darken-4">
          Mrunali Bhosale, JNV Kolhapur </v-btn
        ><br />
        <v-btn text color="green darken-4"> R C Kavya, JNV Ernakulaum </v-btn
        ><br />
        <br />
        <br />
        <v-avatar left> <v-icon>mdi-school</v-icon> </v-avatar>
        <h3>SCHOOLS WITH BEST PARTICIPATION</h3>
        <v-btn text color="deep-orange darken-4"> JNV Jhansi </v-btn><br />
        <v-btn text color="deep-orange darken-4"> JNV Ernakulaum </v-btn><br />
        <v-btn text color="deep-orange darken-4"> JNV Kolhapur </v-btn><br />
      </v-card-text>
    </v-card> -->
    <!-- <v-carousel v-model="model">
      <v-carousel-item v-for="(color, i) in colors" :key="color">
        <v-sheet :color="color" height="100%" tile>
          <v-row class="fill-height" align="center" justify="center">
            <div class="text-h2">Slide {{ i + 1 }}</div>
          </v-row>
        </v-sheet>
      </v-carousel-item>
    </v-carousel> -->
    <!-- <v-sheet height="100%" tile color="white"> </v-sheet>
    <v-row> Shining stars of Sparkle Series </v-row>
    <v-row> </v-row> -->
  </div>
</template>

<script>
export default {
  data() {
    return {
      model: 0,
      colors: ["primary", "secondary", "yellow darken-2", "red", "orange"],
    };
  },
};
</script>

<style>
</style>